import SnappySlider from "../../../../src/components/SnappySlider";
import SnappySlide from "../../../../src/components/SnappySlider/SnappySlide";
import * as React from 'react';
export default {
  SnappySlider,
  SnappySlide,
  React
};